module.exports = __webpack_public_path__ + "sp-logo-554aaa9cf8a5cb539b8a52786e95f551.svg";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/sp-logo.svg
// module id = n5Rb
// module chunks = client